import { ContiguousTimeslot, TimeslotId, Timeslot } from "../timeslots.types";
import { groupTimeslotsByDay } from "./groupTimeslotsByDay";

/**
 * Finds contiguous blocks of selected time slots by adjacent IDs.
 * Returns blocks with inclusive start and exclusive end slot IDs,
 * plus an array of included slot IDs.
 */
export function findContiguousTimeslots(
  selected: Timeslot[]
): ContiguousTimeslot[] {
  const blocks: ContiguousTimeslot[] = [];

  const slotsByDay = groupTimeslotsByDay(selected);

  for (const [dayIndexStr, daySlots] of Object.entries(slotsByDay)) {
    const day = Number(dayIndexStr);
    const sorted = [...daySlots].sort((a, b) => a.id - b.id);

    let blockStart = 0;

    for (let i = 1; i <= sorted.length; i++) {
      const prev = sorted[i - 1];
      const curr = sorted[i];

      const isEndOfBlock = !curr || curr.id !== prev.id + 1;

      if (isEndOfBlock) {
        const start = sorted[blockStart];
        const end = sorted[i - 1];

        const slotIds = sorted
          .slice(blockStart, i)
          .map((slot) => slot.id as TimeslotId);

        const duration = (slotIds.length * 30) / 60;

        blocks.push({
          day,
          duration,
          startTimeSlotId: start.id,
          endTimeSlotId: (end.id < 335 ? end.id + 1 : end.id) as TimeslotId,
          slotIds,
        });

        blockStart = i;
      }
    }
  }

  return blocks.sort((a, b) =>
    a.day !== b.day ? a.day - b.day : a.startTimeSlotId - b.startTimeSlotId
  );
}

export default findContiguousTimeslots;
